/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type tradeDesignManagerOnboardingQueryVariables = {
    userId: string;
};
export type tradeDesignManagerOnboardingQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly isVerifiedTrade: boolean | null;
            readonly tradeFirmDesignManagerProfile: {
                readonly hasAccount: unknown | null;
            } | null;
        } | null;
    } | null;
};
export type tradeDesignManagerOnboardingQuery = {
    readonly response: tradeDesignManagerOnboardingQueryResponse;
    readonly variables: tradeDesignManagerOnboardingQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVerifiedTrade",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "tradeFirmDesignManagerProfile",
  "storageKey": null,
  "args": null,
  "concreteType": "TradeFirmDesignManagerProfileType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasAccount",
      "args": null,
      "storageKey": null
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "tradeDesignManagerOnboardingQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "tradeDesignManagerOnboardingQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "tradeDesignManagerOnboardingQuery",
    "id": "ferrum/237.0.0-2019-10-15T13:09:02.443Z/tradeDesignManagerOnboardingQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'c1575976a530aad1d0e163717f7c2a7b';
export default node;
